import React, { PropsWithChildren } from 'react';
import './DossiersContainer.scss';
import { ERouterPath } from '../router/ERouterPath';
import { useHistory } from 'react-router';
import { Icon } from '../icon/Icon';
import Spinner from 'react-bootstrap/Spinner';
import { DossiersTable } from '../files-table/DossiersTable';
import { SingleUser, UserAccountRoleEnum } from '../../api/types';
import { DossierV2, IDossierWithOptionalRelation } from '../../models/DossierV2';
import { ApplicationState } from '../../app/store';
import { useSelector } from 'react-redux';
import { MultiDossierUnreadStatus } from '../../models/UnreadStatus';
import { Badge } from '../badge/Badge';

interface IDossiersContainerProps {
  dossiersWithRelation: IDossierWithOptionalRelation[];
  loading: boolean;
  unreadStatus: MultiDossierUnreadStatus;
  showAllDossiers?: boolean;
  onArchiveDossier: (dossier: DossierV2) => void;
  onUnarchiveDossier: (dossier: DossierV2) => void;
}

export function DossiersContainer({ dossiersWithRelation, loading, showAllDossiers, unreadStatus, onArchiveDossier, onUnarchiveDossier }: PropsWithChildren<IDossiersContainerProps>): JSX.Element {
  const user = useSelector<ApplicationState, SingleUser|undefined>(state => state.session.user);
  const canSeeAllDossiers = user && [UserAccountRoleEnum.adminCaregiver, UserAccountRoleEnum.administration].includes(user.accountRole);
  const canSeePersonalDossiers = user && [UserAccountRoleEnum.adminCaregiver, UserAccountRoleEnum.caregiver].includes(user.accountRole);
  const history = useHistory();
  const myDossiersTitle = 'Mijn Dossiers';
  const allDossiersTitle = 'Alle Dossiers';

  const handleClick = (goTo: ERouterPath): void => {
    history.push(goTo);
  };

  const renderTitleButton = (title: string, goTo: ERouterPath): JSX.Element => (
    <button className="dossiers__btn dossiers__btn--title" onClick={() => handleClick(goTo)}>
      {title}
    </button>
  );

  const renderTable = (): JSX.Element => {
    if (loading) {
      return <Spinner animation="border" role="status" />;
    }

    return <DossiersTable dossiersWithRelation={dossiersWithRelation} badges={unreadStatus} onArchiveDossier={onArchiveDossier} onUnarchiveDossier={onUnarchiveDossier} />;
  };

  return (
    <div className="dossiers__container">
      <div className="dossiers__header">
        <div className="dossiers__switch">
          {
            canSeePersonalDossiers &&
            <h2 className="dossiers__title dossiers__title--my-dossiers">
              { showAllDossiers ? renderTitleButton(myDossiersTitle, ERouterPath.personalDossiers) : <span>{myDossiersTitle}</span> }
            </h2>
          }
          {
            canSeeAllDossiers &&
            <h2 className="dossiers__title dossiers__title--all-dossiers">
              { showAllDossiers ? <span>{allDossiersTitle}</span> : renderTitleButton(allDossiersTitle, ERouterPath.allDossiers) }
            </h2>
          }
          <Badge className="dossiers__title-badge" count={unreadStatus.total} />
        </div>
        <div className="dossiers__options">
          <button className="dossiers__btn dossiers__btn--add-dossier" onClick={() => handleClick(ERouterPath.newDossier)}>
            <Icon icon="add" />
            Nieuw dossier
          </button>
          <button className="dossiers__btn dossiers__btn--all-persons" onClick={() => handleClick(ERouterPath.listPersons)}>
            <Icon icon="allpersons" />
            Alle personen
          </button>
        </div>
      </div>
      <div className="dossiers__items">
        { renderTable() }
      </div>
    </div>
  );
}
